import React from 'react';
import styled from 'styled-components/macro';
import { Button } from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import { ProjectStatus } from 'consts/statuses';
import { ReactComponent as CheckIcon } from 'assets/icons/Check.svg';

const StyledButton = styled(Button)`
  border: 1px solid #e3e5e8;
  min-width: fit-content;
  margin-left: 0.5rem;
`;

const StyledNotification = styled.div`
  background-color: #eafbea;
  color: #253858;
  min-height: 3.5rem;
  font-size: 0.875rem;
  padding: 1.375rem 2rem 1.375rem 1.16rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  border-radius: 4px;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

const NotificationContent = styled.div`
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 1rem;
  margin-right: 0.66rem;
`;

type ProjectStatusNotificationProps = {
  status: number;
  ctaAction: () => void;
  isManualDataCollection?: boolean;
};

const ProjectStatusNotification = ({
  status,
  ctaAction,
  isManualDataCollection,
}: ProjectStatusNotificationProps) => {
  const t = useFormatMessage();

  return (
    <div>
      {status === ProjectStatus.COLLECTING_DATA ||
      status === ProjectStatus.FINISHED ? (
        <StyledNotification>
          <NotificationContent>
            <IconContainer>
              <CheckIcon />
            </IconContainer>
            <span>
              {status === ProjectStatus.COLLECTING_DATA
                ? t(
                    'dataCollection.notification.progress',
                    'Data collection has started. You can track progress and keep adding more contacts.'
                  )
                : isManualDataCollection
                ? t(
                    'dataCollection.notification.manual.complete',
                    'Data collection is now complete. Data from surveys is no longer collected. '
                  )
                : t(
                    'dataCollection.notification.complete',
                    'Data collection is complete. You can view all collected data in a report.'
                  )}
            </span>
          </NotificationContent>
          <StyledButton variant="secondary" onClick={ctaAction}>
            {status === ProjectStatus.COLLECTING_DATA
              ? t('dataCollection.notification.progress.cta', 'Track Progress')
              : t('project.testEdit.viewReport', 'View Report')}
          </StyledButton>
        </StyledNotification>
      ) : null}
    </div>
  );
};

export default ProjectStatusNotification;
